<template>
  <div class="container w-full flex flex-wrap mx-auto px-2 pt-8 lg:pt-16 md:pt-16 mt-12">
    <div class="w-full mt-4 px-2 lg:px-24 md:px-24">
      <div class="text-center text-lg text-background-secondary bg-gray-100 p-5" v-html="errorMsg"></div>
    </div>
  </div>
</template>
<script>
import { defineComponent, onBeforeMount, ref } from 'vue';

export default defineComponent({
  name: 'NotFound',

  setup() {
    const errorMsg = ref();
    const renderReady = ref();
    // const helpmateLink = ref(localStorage.getItem('helpmateLink'));
    onBeforeMount(async () => {
      renderReady.value = false;
      errorMsg.value = localStorage.getItem('errorMsg');
      renderReady.value = true;
    });
    return { errorMsg, renderReady };
  },
});
</script>
